import React, { useEffect, useRef, useState } from 'react';
import './importMediaDialog.css';
import SuccessMessage from '../../../common/successMsg';
import httpService from '../../../../services/http.service';
import ErrorMessage from '../../../common/errorMsg';
import UploadFileSkull from './uploadFileSkull';
import WarningMessage from '../../../common/warnMsg';



function ImportMediaDialog({ onClose, storage, folderStructure }) {
    const [fileData, setFileData] = useState([]);
    const [fileProccesing, setFileProcessing] = useState([]);
    const fileInputRef = useRef(null);
    const [selectedTab, setSelectedTab] = useState("existing_folder")
    const [folderName, setFolderName] = useState("")



    const handleFileChange = (event) => {
        setFileData([...event.target.files]);
    };

    const deleteFiles = (index) => {
        setFileData((prevData) => prevData.filter((_, idx) => {
            return idx !== index
        }));
    };

    const handleImport = async () => {
        try {

            let totalSizeInByte = 0
            fileData.forEach((item) => {
                totalSizeInByte += item.size;
            })

            if (totalSizeInByte > 103808960) {
                WarningMessage("File Too Large: The selected file exceeds the 99 MB limit. Please upload a smaller file.")
                return
            }


            if (!fileData?.length)
                return ErrorMessage("Please select a File");
            for (const file of fileData) {
                setFileProcessing(old => [...old, { percent: 0, fileName: file.name }])
                await httpService.uploadFileNas("upload-google-storage-files", file, storage, setFileProcessing, folderName);
                setFileProcessing(old => old.map(ele => ele.fileName === file.name ? { ...ele, percent: 100 } : ele))
            }
            SuccessMessage(`${fileData.length} files Successfully uploaded`)
            setFileData([])
            setFileProcessing([])
            setSelectedTab("existing_folder")
            setFolderName("")
        } catch (error) {
            ErrorMessage(error.message || "An error occurred during file upload");
        } finally {
            setFileData([])
        }
    };

    const handleCancel = () => {
        setFileData(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        if (typeof onClose === "function")
            setFileData([])
    };

    const handleFolderNameChange = (e) => {
        const input = e.target.value;
        // Remove any character that is not a-z, A-Z, or 0-9
        const filteredInput = input.replace(/[^a-zA-Z0-9 ]/g, '');
        setFolderName(filteredInput);
    };

    useEffect(() => {
        setFolderName("")
    }, [selectedTab])


    return (
        <div style={{
            height: fileData?.length ? 300 : "auto",
            overflowY: 'scroll',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        }}
        >
            {!fileData?.length ?
                <>
                    <div className="import-options">
                        <div style={{}}>
                            <div style={{ marginBottom: 10 }}>
                                <div style={{ display: "flex" }}>
                                    <input type='radio' value="existing_folder" checked={selectedTab === "existing_folder"} onChange={() => setSelectedTab("existing_folder")} placeholder='Select the existing folder' style={{ cursor: "pointer" }} />
                                    <p style={{ marginLeft: 3 }}>Select the existing folder</p>
                                </div>
                                {selectedTab === "existing_folder" && (
                                    <select
                                        style={{
                                            width: "100%",
                                            height: 51,
                                            borderRadius: 0,
                                            padding: "0px 10px",
                                            backgroundColor: "rgb(255, 235, 243)"
                                        }}
                                        defaultValue=""
                                        onChange={e => setFolderName(e.target.value)}
                                    >
                                        <option disabled value="">Select the folder</option>
                                        {folderStructure && folderStructure
                                            ?.filter(ele => ele.type === "folder")
                                            .map(ele => (
                                                <option key={ele.name} value={ele.name}>
                                                    {ele.name}
                                                </option>
                                            ))}

                                    </select>
                                )}
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <div style={{ display: "flex" }}>
                                    <input type='radio' value="new_folder" checked={selectedTab === 'new_folder'}
                                        onChange={() => setSelectedTab('new_folder')} placeholder='Create a folder' style={{ cursor: "pointer" }} />
                                    <p style={{ marginLeft: 3 }}>Create a New folder</p>
                                </div>
                                {selectedTab === "new_folder" && <input type='text' placeholder='Enter a folder name' value={folderName} onChange={(e) => handleFolderNameChange(e)} style={{ backgroundColor: "rgb(255, 235, 243)", padding: 5, height: 51, width: "100%", outline: "none" }} />}
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <div style={{ display: "flex" }}>
                                    <input type='radio' value="upload_file" checked={selectedTab === "upload_file"} onChange={() => setSelectedTab('upload_file')} placeholder='Upload a file' style={{ cursor: "pointer" }} />
                                    <p style={{ marginLeft: 3 }}>Upload a File directly</p>
                                </div>
                            </div>
                            <input
                                id="formFile"
                                data-testid="formFile"
                                disabled={folderName || selectedTab === "upload_file" ? false : true}
                                type="file"
                                multiple
                                accept=".mp3, .wav, .png, .jpg, .jpeg,"
                                ref={fileInputRef}
                                onChange={(e) => handleFileChange(e)}
                            />
                        </div>

                    </div>
                    <div className='btns'>
                        <button className='btn btn-danger' onClick={onClose}>Close</button>
                    </div>
                </>
                :
                <>
                    <div className="progress-container" data-testid="progressBar">
                        <h4 style={{ marginBottom: 15 }}>{fileProccesing.length ? fileData.length === fileProccesing.length ? "Uploaded" : "Uploading" : "Selected"} Files ({fileData.length})</h4>
                        {fileData.map((file, index) => {
                            return <UploadFileSkull key={index} deleteFiles={() => deleteFiles(index)} file={file} fileProcces={fileProccesing.find(old => old.fileName === file.name)} isInQueue={fileProccesing.length} />
                        })}
                    </div>
                    <div className='btns'>
                        <button className='btn btn-primary' disabled={fileProccesing.length} onClick={handleImport}>Import</button>
                        <button className='btn btn-danger' disabled={fileProccesing.length} onClick={handleCancel}>Clear</button>
                    </div>
                </>
            }
        </div>
    );
}

export default ImportMediaDialog;